// Copied from `@classdojo/teach`

type Item = {
  firstName?: string;
  lastName?: string;
  name?: string;
};

export function fullName(obj: Item) {
  if (!obj) return "";

  const { firstName, lastName } = obj;
  if (!firstName && !lastName) return "";
  return [firstName || "", lastName || ""].join(" ").trim();
}

export function standardizeString(string: string) {
  const stripped = string.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");
  return stripped.toLowerCase();
}

// For now, just doing by exact match because it's quicker
export default function filterByName<T extends Item>(list: T[], name: string): T[] {
  const isPersonList = list.every(({ firstName, lastName }) => {
    return typeof firstName === "string" && typeof lastName === "string";
  });
  const isClassList = list.every(({ name }) => typeof name === "string");

  if (!isPersonList && !isClassList) throw new Error("List doesn't have valid names");
  if (typeof name !== "string") throw new Error("Needs to filter by string");
  if (name.length === 0) return list;

  list = list.filter(({ firstName, lastName }) => firstName || lastName);

  const exactMatchesFromStart: T[] = [];
  const partialMatches: T[] = [];
  const search = standardizeString(name);

  list.forEach((item) => {
    const itemName = isPersonList ? standardizeString(fullName(item)) : standardizeString(item.name!);
    const nameIndex = itemName.indexOf(search);
    if (search === itemName) {
      exactMatchesFromStart.unshift(item);
    } else if (nameIndex === 0) {
      exactMatchesFromStart.push(item);
      return;
    } else if (nameIndex >= 0) {
      partialMatches.push(item);
    }
  });

  return exactMatchesFromStart.concat(partialMatches);
}
